import { useAIStore } from "../../stores/aiStore.js";
import { DiffViewer } from "../ui/DiffViewer.js";
import { Button } from "../ui/Button.js";
import type { JsonPatch } from "../../types/ai.js";

export function PatchPreview({ patch }: { patch: JsonPatch[] }) {
  const applyPatch = useAIStore((state) => state.applyPatch);
  const rejectPatch = useAIStore((state) => state.rejectPatch);
  const summary = useAIStore((state) => state.patchSummary);

  return (
    <div style={{ background: "#f8fafc", border: "1px solid #dbe3ea", borderRadius: 8, padding: 12 }}>
      <div style={{ fontSize: 12, color: "#475569", fontWeight: 800, marginBottom: 8 }}>
        {summary?.split("\n")[0] ?? "変更内容のプレビュー"}
      </div>
      <DiffViewer patch={patch} />
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <Button variant="primary" onClick={applyPatch}>適用する</Button>
        <Button onClick={rejectPatch}>破棄</Button>
      </div>
    </div>
  );
}
